import { useEffect } from 'react';

/**
 * Locks body scroll while `locked` is true. Restores the prior overflow value
 * on cleanup or when `locked` flips back to false.
 *
 * Handles iOS Safari visual/layout viewport divergence that pushes fixed
 * bottom sheets off-screen after page scroll.
 */
export function useBodyScrollLock(locked: boolean): void {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (!locked) return;

    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = prev;
    };
  }, [locked]);
}
